// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarParticipantAvatar__container-d9e004 {
  position: relative;
}

.CalendarParticipantAvatar__status-ee57d1 {
  width: 22px;
  height: 22px;
  position: absolute;
  right: -6px;
  bottom: -6px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--participant-status-bg-color);
  border: 2px solid var(--base-0);
  box-sizing: border-box;
}

.CalendarParticipantAvatar__icon-f51004 {
  fill: var(--participant-status-icon-color);
}

.CalendarParticipantAvatar__confirmation-type-maybe-b2973d,
.CalendarParticipantAvatar__confirmation-type-awaiting-bc05c5 {
  --participant-status-bg-color: var(--base-30);
  --participant-status-icon-color: var(--base-70);
}

.CalendarParticipantAvatar__confirmation-type-accepted-c70e08 {
  --participant-status-bg-color: var(--success-40);
  --participant-status-icon-color: var(--addition-50);
}

.CalendarParticipantAvatar__confirmation-type-declined-d613bb {
  --participant-status-bg-color: var(--danger-40);
  --participant-status-icon-color: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/components/CalendarParticipantAvatar/CalendarParticipantAvatar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,+BAAA;EACA,sBAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;;EAEE,6CAAA;EACA,+CAAA;AACF;;AAEA;EACE,gDAAA;EACA,mDAAA;AACF;;AAEA;EACE,+CAAA;EACA,mDAAA;AACF","sourcesContent":[".container {\n  position: relative;\n}\n\n.status {\n  width: 22px;\n  height: 22px;\n  position: absolute;\n  right: -6px;\n  bottom: -6px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: var(--participant-status-bg-color);\n  border: 2px solid var(--base-0);\n  box-sizing: border-box;\n}\n\n.icon {\n  fill: var(--participant-status-icon-color);\n}\n\n.confirmation-type-maybe,\n.confirmation-type-awaiting {\n  --participant-status-bg-color: var(--base-30);\n  --participant-status-icon-color: var(--base-70);\n}\n\n.confirmation-type-accepted {\n  --participant-status-bg-color: var(--success-40);\n  --participant-status-icon-color: var(--addition-50);\n}\n\n.confirmation-type-declined {\n  --participant-status-bg-color: var(--danger-40);\n  --participant-status-icon-color: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CalendarParticipantAvatar__container-d9e004`,
	"status": `CalendarParticipantAvatar__status-ee57d1`,
	"icon": `CalendarParticipantAvatar__icon-f51004`,
	"confirmation-type-maybe": `CalendarParticipantAvatar__confirmation-type-maybe-b2973d`,
	"confirmationTypeMaybe": `CalendarParticipantAvatar__confirmation-type-maybe-b2973d`,
	"confirmation-type-awaiting": `CalendarParticipantAvatar__confirmation-type-awaiting-bc05c5`,
	"confirmationTypeAwaiting": `CalendarParticipantAvatar__confirmation-type-awaiting-bc05c5`,
	"confirmation-type-accepted": `CalendarParticipantAvatar__confirmation-type-accepted-c70e08`,
	"confirmationTypeAccepted": `CalendarParticipantAvatar__confirmation-type-accepted-c70e08`,
	"confirmation-type-declined": `CalendarParticipantAvatar__confirmation-type-declined-d613bb`,
	"confirmationTypeDeclined": `CalendarParticipantAvatar__confirmation-type-declined-d613bb`
};
module.exports = ___CSS_LOADER_EXPORT___;
